<template>
  <!-- questionId と bookId からユーザーの問い配列、本の問い配列、問いコレクションのドキュメントを削除するボタンのコンポーネントです。
  ↓使用方法↓
<DeleteQuestionBtn :bookId="{問いがある本のID}" :questionId="{問いのID}" /> -->

  <b-button
    variant="dark my-3"
    size="sm"
    @click="deleteQuestion(questionId, bookId)"
    >削除</b-button
  >
</template>

<script>
import { db } from "@/firebase";

export default {
  props: ["questionId", "bookId"],
  data() {
    return {};
  },
  methods: {
    deleteQuestion(qId, bId) {
      if (window.confirm("本当に削除しますか？")) {
        //ユーザーの問い配列から削除
        const userQuestions = this.$store.getters.user.questions;
        userQuestions.forEach((questionId, index) => {
          if (questionId == qId) {
            userQuestions.splice(index, 1);
          }
        });
        this.$store.dispatch("updateUserData", { questions: userQuestions });
        //本の問い配列から削除
        const bookRef = db.collection("books").doc(bId);
        db.runTransaction(transaction => {
          return transaction.get(bookRef).then(doc => {
            const bookQuestions = doc.data().questions;
            console.log("questions ", bookQuestions);
            bookQuestions.forEach((questionId, index) => {
              if (questionId == qId) {
                bookQuestions.splice(index, 1);
              }
            });
            transaction.update(bookRef, { questions: bookQuestions });
          });
        })
          .then(function() {
            console.log("Transaction successfully committed!");
          })
          .catch(function(error) {
            console.log("Transaction failed: ", error);
          });
        //問いコレクションから削除
        db.collection("questions")
          .doc(qId)
          .delete()
          .then(function() {
            console.log("Document successfully deleted!");
          })
          .catch(function(error) {
            console.error("Error removing document: ", error);
          });
      }
    }
  }
};
</script>
